module.exports = {"width":303,"height":201,"type":"png"}